const additionCookieKey = __ENVIRONMENT__ === "prod_kz" || __ENVIRONMENT__ === "prod_pro" || __ENVIRONMENT__ === "demo"
  ? "" : __ENVIRONMENT__;

export const authConstants = Object.freeze({
  refreshToken: `refreshTokenAdmin${additionCookieKey}`,
  accessToken: `accessTokenAdmin${additionCookieKey}`,
  typeToken: `typeTokenAdmin${additionCookieKey}`,
  userId: `userIdAdmin${additionCookieKey}`,
  language: `adminLanguage${additionCookieKey}`,
  hasPrivilege: `hasPrivilege${additionCookieKey}`,
  serviceToolsTokenAdmin: `serviceToolsTokenAdmin${additionCookieKey}`,
  tenant: `tenant${additionCookieKey}`
})